/* eslint-disable react/display-name */
import React from 'react'
import Highlight, { defaultProps } from 'prism-react-renderer'
import Prism from 'prism-react-renderer/prism'
import theme from 'prism-react-renderer/themes/vsDark'
import { CheckmarkBackgroundIcon } from '@paypalcorp/pp-react'

import './code-blocks.css'
import { CopyButton } from '..'
import NewCopyIcon from '../../../components/icons/newCopy'
import {
  copyToClipboard,
  createLineNumberArray,
  getCodeLineStyle,
} from '../../../utils'
import withAnalytics from '../../../utils/withAnalytics'
import { removeGAParam } from '../../pp-react-wrappers'

const CodeBlock = ({
  children,
  className,
  label = 'copy-content',
  drag = false,
  hasOwnCopyBlock = false,
  highlightLines = '',
}: any) => {
  const [isCopied, setIsCopied] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const language = className && className.replace(/language-/, '')
  const gaData = typeof window !== 'undefined' && (window as any).ga
  const linesToHighlight = createLineNumberArray(highlightLines)

  const handleCopyClipboard = (isButton = false) => {
    const fptiData = typeof window !== `undefined` && window.fpti
    setLoading(true)

    if (isButton) {
      copyToClipboard(children)
    }

    setTimeout(() => {
      setLoading(false)
      setIsCopied(true)
    }, 2000)

    setTimeout(() => {
      setIsCopied(false)
    }, 4000)

    if (fptiData) {
      const options = {
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          e: 'cl',
          link: label,
          component: 'devdiscoverynodeweb',
          space_key: 'SKEXJE',
          event_name: `${fptiData.page.replace(/:/g, '_')}_copy_button_pressed`,
          page_name: fptiData.page.replace(/:/g, '_'),
          pu: removeGAParam(window.location.href),
        },
      }

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.record(options)
      }
    }

    if (gaData) {
      gaData('send', 'event', {
        eventCategory: 'codeblock',
        eventAction: 'click',
        eventLabel: 'copyContent',
      })
    }
  }

  ;(typeof global !== 'undefined' ? global : window).Prism = Prism
  require('prismjs/components/prism-php')
  require('prismjs/components/prism-java')
  require('prismjs/components/prism-ruby')
  require('prismjs/components/prism-aspnet')
  require('prismjs/components/prism-csharp')
  require('prismjs/components/prism-kotlin')

  return (
    <div onCopy={() => handleCopyClipboard()}>
      {/* @ts-ignore: Temporary fix for TypeScript compatibility issue */}
      <Highlight
        {...defaultProps}
        theme={theme}
        code={children.trim()}
        language={language}
      >
        {({ className, style, tokens, getLineProps, getTokenProps }) => {
          return (
            <>
              {hasOwnCopyBlock ? null : (
                <div className="copyBtn-wrapper">
                  <CopyButton onClick={() => handleCopyClipboard(true)}>
                    {loading && <div className="loader" />}
                    {isCopied && (
                      <CheckmarkBackgroundIcon
                        size="lg"
                        className="checkmark-bg-icon"
                        color="sysColorAccent3Main"
                      />
                    )}
                    {!loading && !isCopied && <NewCopyIcon />}
                  </CopyButton>
                </div>
              )}
              <pre
                className={`${className} noHighlight`}
                style={{
                  ...style,
                  background: '#1e204c',
                  border: 0,
                  borderRadius: '0.5rem',
                  color: '#eee',
                  position: 'relative',
                  padding: '0.5rem 1.5rem 1.5rem',
                  fontSize: '0.9375rem',
                  marginTop: '0',
                }}
              >
                {tokens.map((line, i) => (
                  <div
                    key={i}
                    {...getLineProps({ line, key: i })}
                    className="line"
                  >
                    <span className="line-number">{i + 1}</span>
                    <span
                      className="line-content"
                      style={getCodeLineStyle(i + 1, linesToHighlight)}
                    >
                      {line.map((token, key) => (
                        <span key={key} {...getTokenProps({ token, key })} />
                      ))}
                    </span>
                  </div>
                ))}
              </pre>
            </>
          )
        }}
      </Highlight>
    </div>
  )
}

export default withAnalytics(CodeBlock)
